"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResultInput = ResultInput;
var _react = _interopRequireDefault(require("react"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _material = require("@mui/material");
var _reactHookForm = require("react-hook-form");
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ResultInput({
  control,
  errors,
  setValue
}) {
  const nd_score = Number((0, _reactHookForm.useWatch)({
    control,
    name: 'nd_score'
  }));
  const opp_score = Number((0, _reactHookForm.useWatch)({
    control,
    name: 'opp_score'
  }));

  // Set the result based on the score
  _react.default.useEffect(() => {
    if (nd_score && opp_score) {
      if (nd_score > opp_score) {
        setValue('result', 'W');
      } else if (nd_score < opp_score) {
        setValue('result', 'L');
      } else {
        setValue('result', 'T');
      }
    }
  });
  return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: "result",
    control: control,
    render: ({
      field: {
        onChange,
        value = '',
        ...rest
      }
    }) => {
      return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
        size: "small",
        disabled: true
      }, /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
        id: "result"
      }, "Result"), /*#__PURE__*/_react.default.createElement(_Select.default, {
        labelId: "result",
        id: "result-select",
        value: value,
        label: "Result",
        sx: {
          width: 100
        }
        // onChange={onChange}
        ,
        inputProps: {
          readOnly: true
        }
      }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        value: "W"
      }, "Win"), /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        value: "L"
      }, "Loss"), /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        value: "T"
      }, "Tie")));
    }
  });
}